import { Navigate, Outlet, useOutletContext } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { RouteContext } from 'modules/employees/lib/types'
import CollectionsBootstrap from 'modules/reviews/lib/EmployeesCollectionsBootstrap'

const Container = () => {
  const { navigation } = useNavigation()
  const context = useOutletContext<RouteContext>()
  const { loadingModuleAvailabilities, hasReviews, hasPerformanceFullVisiblity } = context

  if (loadingModuleAvailabilities)
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )

  if (!hasReviews && hasPerformanceFullVisiblity)
    return <Navigate replace to={navigation.appStore.fullPath()} />

  if (!hasReviews) return <NotFound />

  return <Outlet context={context} />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
